
import { defineComponent, ComputedRef, Ref, ref, onMounted, reactive, computed, toRaw, watch } from 'vue'
import { useStore } from 'vuex'
import {StateType as AreaStateType} from '@/store/area'
import {StateType as UseraddressStateType} from '@/store/useraddress'


import { Props, validateInfos } from "ant-design-vue/lib/form/useForm";
import { message, Form } from "ant-design-vue";
const useForm = Form.useForm;
import useI18nAntdFormVaildateInfos from "@/composables/useI18nAntdFormVaildateInfos";
import dayjs from "dayjs";
import { cloneDeep, debounce } from "lodash";

import {AreaParams} from '@/services/data.d'
import { FromDataType } from '../../data.d'

import {arealistFn} from '@/utils/array'

interface AddressSetupData {
    arealistEn: Ref<any[]>;
    arealist: Ref<any[]>;
    modelRef: FromDataType;
    validateInfos: ComputedRef<validateInfos>;
    typeshow: Ref<boolean>;
    typeTipshow:Ref<boolean>;
    modetype: Ref<boolean>;
    labelHtxt: ComputedRef<string>;
    labelTxt: ComputedRef<string>;
    state: any;
    slist: Ref<any[]>;
    arealistReturn: Ref<any[]>;
    handleCtrl: (e: MouseEvent) => void;
    handleSelectType: (e: MouseEvent) => void;
    handleModeType: (e: MouseEvent) => void;
    handleSubmit: (e: MouseEvent) => Promise<void>;
    handleSearch: (e: MouseEvent) => void;
    handleStation: (e: MouseEvent) => void;
    handleGetStation: (e: MouseEvent) => void;
}

export default defineComponent({
    name: 'Address',
    emits: ['update:visible', 'formData'],
    props: {
        typeStr: String
    },
    setup(props,{emit}): AddressSetupData {
        const store = useStore<{area:AreaStateType,useraddress:UseraddressStateType}>()
        const arealistEn = ref<any[]>([])
        const arealist = ref<any[]>([])
        const typeshow = ref<boolean>(true)
        const typeTipshow = ref<boolean>(false)
        const modetype = ref<boolean>(false)
        const arealistReturn =  ref<any[]>([])
        const type = props.typeStr
        const state = reactive({data:[]})
        const userMsg = JSON.parse(localStorage.getItem('userMsg') as string)
        const slist = ref<any[]>([]) //站点信息
        let lastFetchId = 0
        
        //地址类型改变时相对应的label改变
        const labelHtxt = computed<string>(() => {
            const { addressType } = modelRef
            const tobj = {
                1: '地址',
                2: '发货地址',
                3: '退运地址',
                default: '地址'
            }
            return tobj[String(addressType)] || tobj['default']
        })

        //交运方式改变时相对应的label改变
        const labelTxt = computed<string>(() => {
            const { deliveryType } = modelRef
            const tobj = {
                1: '联系地址',
                2: '邮寄地址',
                3: '自送地址',
                default: '联系地址'
            }
            return tobj[String(deliveryType)] || tobj['default']
        })

        //取消弹框
        const handleCtrl = (e: MouseEvent) => {
            e.preventDefault()
            emit('update:visible', false)
        }

        //获取地址
        const areaList = async(params:AreaParams) => {
            try {
                const res:boolean = await store.dispatch('area/getAreaFn', params)
                if(res){
                    modelRef.addressType == 1 ? arealist.value = localStorage.getItem('Area4PickupList') && JSON.parse(String(localStorage.getItem('Area4PickupList'))) : arealist.value = arealistFn(store.state.area.arealist,1);
                    arealistEn.value = arealistFn(store.state.area.arealist,2)
                    arealistReturn.value = store.state.area.arealist
                }
            } catch (error) {
                message.warning('获取地区信息失败!')
            }
        }

        //提交
        const modelRef = reactive<FromDataType>({
            codeAndName: {label:'',value: ''},
            addressType: 2, //地址类型
            addressName: '', //常用地址名称
            contacts: '', //联系人姓名
            mobilePhone: '', //手机号码
            zipCode: '', //邮政编码
            address1: [], //地址
            street: '', //街道
            detailedAddress: '', //详细地址
            deliveryType: 1, //交运方式
            pickupCycle: [], //揽件周期
            site: null, //站点地址
            isDefault: false, //是否默认-启用-停用
            isDefaultReturn: false,
            returnName: '',
            returnPhone: '',
            returnCityName: [], 
            returnDetailed: '',
            returnAddress:{
                name: '',
                phone: '',
                province: '',
                city: '',
                region: '',
                detailedAddress: '',
            }
        })
        const rulesRef = reactive({
            returnName: [
                {
                    required: true,
                    message: '请输入退件联系人姓名'
                }
            ],
            returnPhone: [
                {
                    required: true,
                    message: '请输入退件联系人手机号码'
                }
            ],
            returnCityName: [
                {
                    required: true,
                    message: '请选择退件联系地址'
                }
            ],
            returnDetailed: [
                {
                    required: true,
                    message: '请输入退件详细地址'
                }
            ],
            codeAndName: [
                {
                    required: true,
                    message: '请选择客户名及编码'
                }
            ],
            addressType: [
                {
                    required: true,
                    message: '请选择地址类型'
                }
            ], 
            addressName: [
                {
                    required: true,
                    message: '请输入常用地址名称'
                }
            ], 
            contacts: [
                {
                    required: true,
                    message: '请输入联系人姓名'
                }
            ], 
            mobilePhone: [
                {
                    required: true,
                    message: '请输入手机号码'
                }
            ],
            zipCode: [
                {
                    required: true,
                    message: '请输入邮政编码'
                }
            ], 
            address1: [
                {
                    required: true,
                    message: '请选择地址'
                }
            ], 
            street:[
                {
                    required: false,
                    message: '请输入街道'
                }
            ],
            detailedAddress: [
                {
                    required: true,
                    message: '请输入详细地址'
                }
            ], 
            deliveryType: [
                {
                    required: true,
                    message: '请选择交运方式'
                }
            ], 
            pickupCycle: [], 
            site: [
                {
                    required: false,
                    message: '请选择站点'
                }
            ], 
            isDefault: [],
            isDefaultReturn:[]
        })
        const { validate, validateInfos } = useForm(modelRef,rulesRef)
        const validateInfosNew = useI18nAntdFormVaildateInfos(validateInfos)
        const handleSubmit = async(e: MouseEvent) => {
            e.preventDefault()
            console.log('modelRef.addressType123',modelRef.addressType == 2,modelRef.isDefaultReturn)
            const filesValue = await validate<FromDataType>()
            const nd = cloneDeep(toRaw(filesValue))
            const data = {}
            data['userCode'] = userMsg.userCode
            data['addressType'] = nd.addressType
            data['addressName'] = nd.addressName
            data['contacts'] = nd.contacts
            data['mobilePhone'] = nd.mobilePhone
            data['zipCode'] = nd.zipCode
            data['province'] = (nd.address1 as any[])[0] || ''
            data['city'] = (nd.address1 as any[])[1] || ''
            data['region'] = (nd.address1 as any[])[2] || ''
            data['street'] = nd.street
            data['detailedAddress'] = nd.detailedAddress
            data['isDefault'] = nd.isDefault
            if(modelRef.addressType == 1){
                data['deliveryType'] = nd.deliveryType
                data['pickupCycle'] = (nd.pickupCycle as any[]).join(',')
                nd.deliveryType !==1 ? data['site'] = nd.site : null
                data['isDefaultReturn'] = nd.isDefaultReturn
                data['returnAddress'] = {
                    name: !nd.isDefaultReturn?nd.returnName:'',
                    phone: !nd.isDefaultReturn?nd.returnPhone:'',
                    province: !nd.isDefaultReturn?(nd.returnCityName as any[])[0] || '':'',
                    city: !nd.isDefaultReturn?(nd.returnCityName as any[])[1] || '':'',
                    region: !nd.isDefaultReturn?(nd.returnCityName as any[])[2] || '':'',
                    detailedAddress: !nd.isDefaultReturn?nd.returnDetailed:'',
                }
            }
            const params = {data,type:props.typeStr}
            emit('formData',params)
        }

        //选择发货方式
        const handleSelectType = (e: MouseEvent) => {
            const { addressType } = modelRef
            modelRef.address1 = []
            addressType === 1 ? typeshow.value = true : typeshow.value = false

            addressType === 2 ? typeTipshow.value = true : typeTipshow.value = false
        }

        //选择交运方式
        const handleModeType = (e: MouseEvent) => {
            const { deliveryType } = modelRef
            deliveryType !== 1 ? modetype.value = true : modetype.value = false 
            if(modelRef.deliveryType == 2){
                modelRef.isDefaultReturn = false
                slist.value.filter((item:any) => {
                    if(item.support_self == 0){
                        return item
                    }
                })
            }else if(modelRef.deliveryType == 3){
                modelRef.isDefaultReturn = false
            }
        }

        //模糊查询获取userCode,userName
        const handleSearch = debounce(value => {
            const fetchId = lastFetchId
            state.data = []
            fetch(`${process.env.VUE_APP_APIHOST}/operator/v1/user/queryFuzzyUserList?param=${value}`)
            .then(response => response.json())
            .then(res => {
                if (fetchId !== lastFetchId) {
                return
                }
                const {body} = res
                const data = body.map((item:any) => ({
                    label: item.registerName,
                    value: item.userCode
                }))
                state.data = data
            })
        }, 300)

        //获取站点信息
        const getStationMeg = async(params: any) => {
            try {
                const res: boolean = await store.dispatch('useraddress/getStationListFn',params)
                if(res===true){
                    slist.value = store.state.useraddress.sinfo.slist
                }
            } catch (error) {
                message.warning('error=>'+error)
            }
        }
        watch(state.data, () => {
            state.data = []
        })

        watch(()=>modelRef.deliveryType,(newvalue) => {
            newvalue !== 1 ? rulesRef.site[0].required = true : rulesRef.site[0].required = false
            newvalue !== 1 ? rulesRef.address1[0].required = false : rulesRef.address1[0].required = true
            newvalue !== 1 ? rulesRef.detailedAddress[0].required = false : rulesRef.detailedAddress[0].required = true
        })

        watch(()=>modelRef.addressType,(newValue)=>{
            console.log('modelRef.addressType',newValue,modelRef.isDefaultReturn)
            if(newValue == 2){
                rulesRef.returnName[0].required = false
                rulesRef.returnPhone[0].required = false
                rulesRef.returnCityName[0].required = false
                rulesRef.returnDetailed[0].required = false
                rulesRef.deliveryType[0].required = false
                typeshow.value = false
                typeTipshow.value = true
            }else{
                rulesRef.returnName[0].required = true
                rulesRef.returnPhone[0].required = true
                rulesRef.returnCityName[0].required = true
                rulesRef.returnDetailed[0].required = true
                rulesRef.deliveryType[0].required = true
                typeshow.value = true
                typeTipshow.value = false
            }
        })

        watch(()=>modelRef.isDefaultReturn,(newValue)=>{
            console.log('modelRef.isDefaultReturn',modelRef.isDefaultReturn)
            if(newValue){
                rulesRef.returnName[0].required = false
                rulesRef.returnPhone[0].required = false
                rulesRef.returnCityName[0].required = false
                rulesRef.returnDetailed[0].required = false
            }else{
                rulesRef.returnName[0].required = true
                rulesRef.returnPhone[0].required = true
                rulesRef.returnCityName[0].required = true
                rulesRef.returnDetailed[0].required = true
            }
        })

        const handleStation = (e:MouseEvent) => {
            modelRef.address1 = []
            slist.value.map((item:any) => {
                if(item.stationAddress == e){
                    modelRef.address1.push(item.stationProvince,item.stationCity,item.stationArea)
                }
            })
            console.log(modelRef.address1)
        }

        //选择地址获取站点信息
        const handleGetStation = (e: MouseEvent) => {
            modelRef.address1[0] = changeTxt(modelRef.address1[0],'province')
            modelRef.address1[1] = changeTxt(modelRef.address1[1],'city')
            modelRef.address1[2] = changeTxt(modelRef.address1[2],'region')
            console.log('modelRef.address1',modelRef.address1)
        }

        const changeTxt = (val: string | number, type: string) => {
            const cityList = localStorage.getItem('areaList') && JSON.parse(String(localStorage.getItem('areaList')))
            switch (type) {
                case 'province':
                    return cityList[val] || val
                case 'city':
                    return cityList[val] || val
                case 'region':
                    return cityList[val] || val
            }
        }

        onMounted(() => {
            areaList({countryCode: '156'})
            getStationMeg({})
            arealist.value = localStorage.getItem('Area4PickupList') && JSON.parse(String(localStorage.getItem('Area4PickupList')))
            modelRef.addressType = 2
            if(type == 'add'){
                modelRef.addressType = 2
            }else{
                modelRef.addressType = 1
            }
            console.log('modelRef.addressType',modelRef.addressType)
            if(modelRef.addressType === 2 || modelRef.isDefaultReturn){
                rulesRef.returnName[0].required = false
                rulesRef.returnPhone[0].required = false
                rulesRef.returnCityName[0].required = false
                rulesRef.returnDetailed[0].required = false
                rulesRef.deliveryType[0].required = false
                typeshow.value = false
                typeTipshow.value = true
            }else{
                rulesRef.returnName[0].required = true
                rulesRef.returnPhone[0].required = true
                rulesRef.returnCityName[0].required = true
                rulesRef.returnDetailed[0].required = true
                rulesRef.deliveryType[0].required = true
                typeshow.value = true
                typeTipshow.value = false
            }
        })

        return {
            arealistEn,
            arealist,
            modelRef,
            typeshow,
            typeTipshow,
            modetype,
            labelHtxt,
            labelTxt,
            validateInfos: validateInfosNew,
            state,
            handleCtrl,
            handleSelectType,
            handleModeType,
            handleSubmit,
            handleSearch,
            slist,
            handleStation,
            arealistReturn,
            handleGetStation
        }
    }
})
